import React, { useState, useEffect } from "react";
import axios from "axios";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
function SummaryResume() {
  const [info, setInfo] = useState("");
  const [remove,setRemove] = useState("")
  // const {id,canUserId,isResumeProcessed} = info
  const sum = () => {
    // axios.get("https://anapioficeandfire.com/api/houses/1" )
    axios
      .get("https://apidev.growthgamut.com/ggcanapi/v1/api/can-resume/resume", {
        withCredentials: true,
      })
      .then((res) => {
       
        console.log(res.data);
        setInfo(res.data);
     
      });
  };
  useEffect(() => {
    sum();
  }, []);
 


  let  resumeclear1 = info?.resumeSummary?.replaceAll('o \n', '•') 
  let resumeclear2 = resumeclear1?.replaceAll('• \n' ,'•')
  return (
    <Container
      style={{ maxWidth: "auto", marginTop: "40px !important" }}
      className="card container-card migrator-mt personalDetails-div-1"
    >
      <div style={{paddingLeft:'1rem',display:'inline-block'}}>
        <Link to="/dashboard">
          <i className="material-icons contact-cancel-button pointer">cancel</i>
        </Link>
        <h2>Resume Summary</h2>

     

        {resumeclear2 && resumeclear2?.split("\n").map((item, key) => {
          
          return (
            <span style={{fontSize:'0.875rem'}}key={key}>
             
            
              {item}
              <br />   

              
             
            </span>
          );
        })}

        
       
        </div>
      
    </Container>
  );
}

export default SummaryResume;
